
























































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { EventModel } from '@/models/event';
import { PatientModel } from '@/models/patient';
import { StockItemModel } from '@/models/stock';

@Component({})
export class PatientInfoCard extends Vue {
  @Prop({ required: true })
  private patient!: PatientModel;

  @Prop({ required: false, default: false })
  private loading?: boolean;

  @Prop({ required: false })
  private recentVisitEvent?: EventModel;

  @Prop({ required: false })
  private recentStockItem?: StockItemModel;

  @Prop({ required: false, default: 0 })
  private pendingEventCount?: number;

  @Prop({ required: false, default: 0 })
  private availableStockUnit?: number;

  @Prop({ required: false, default: false})
  private showActions?: boolean;

  hasRecentVisitEvent() {
    return !!this.recentVisitEvent;
  }

  hasRecentStockItem() {
    return !!this.recentStockItem;
  }
}

export default PatientInfoCard;
